import States from 'components/feedback/States';
import type React from 'react';
import type { ReactNode } from 'react';

import './_styles.scss';

interface NoContentProps {
    id?: string;
    title: string;
    body: string | React.JSX.Element;
    button?: ReactNode;
}

const NoContent = ({ id, title, body, button }: NoContentProps) => (
    <States
        data-testid={`system-admin-table-empty-${id}`}
        icon={<span className='rioglyph rioglyph-looking-glass-man NoContent__icon' />}
        title={title}
        body={body}
        button={button}
    />
);

export default NoContent;
